import React from 'react';
import $ from 'jquery';
import NumberFormat from 'react-number-format';
import csvDownload from 'download-csv';
import Utility from '../utilities/utility';

class OrderItem extends React.Component {

    constructor(props) {
        super(props);

    }



    select(orderId, accessLevel) {

        let orderType = this.props.order.type;

        if (Utility.isEmpty(orderType)) {

            return;
        }
        localStorage.setItem('selectedOrder', orderId);

        if (orderType == 'STOCK') {

            window.location.href = '/manager/stock/add/products';

        } else {

            window.location.href = '/orderProduct/add?accessLevel=' + accessLevel;
        }

        //window.location.href = '/orderProduct/add?accessLevel=' + accessLevel;
    }





    async updateDescription(orderId, description) {

        if (description == "" || description == null) {

            $('.message-holder').html(

                '<div class="alert alert-danger order-alert">Entrer la description</div>'
            );

            $('.order-alert').delay(3000).fadeOut('slow');



            return;
        }

        try {
            const response = await this.props.orderService.updateOrderDescription(orderId, description);
            const order = await response.json();

            $('.desc-' + orderId).html(order.description);

        } catch (error) {

        }


    }

    updateStatus = async (orderId, statusId) => {

        this.props.orderService.updateOrderStatus(orderId, statusId);

    }

    updateSupplier = async (orderId, supplierId) => {

        try {

            const response = await this.props.orderService.setOrderSupplier(orderId, supplierId);
            if (response.ok) {

                $('#order-item-row-' + orderId).before(

                    '<div class="alert alert-success order-alert">Fornisseur mis a jour</div>'
                );

                $('.order-alert').delay(3000).fadeOut('slow');

            } else {

                $('#order-item-row-' + orderId).before(

                    '<div class="alert alert-danger order-alert">Probleme lors du mis a jour</div>'
                );

                $('.order-alert').delay(3000).fadeOut('slow');
            }

        } catch (error) {

            $('#order-item-row-' + orderId).before(

                '<div class="alert alert-danger order-alert">Probleme lors du mis a jour</div>'
            );

            $('.order-alert').delay(3000).fadeOut('slow');
        }



    }

    exportOrderToCSV = async (orderId) => {

        const response = await this.props.orderService.printProducts(orderId);
        const printData = await response.json();



        const columns = { name: 'Nom', model: 'Modele', brand: 'Marque', size: 'Numero', color: 'Couleur', cpid: 'CPID', quantity: 'Quantité', price: 'Prix' };

        //csvDownload(printData, columns, 'commande exportée');

        Utility.jsonToExcel("Produits", printData);

    }

    updateOrderCurrency = async () => {

        const orderId = this.props.order.orderId;
        let currencyId = $('#currencyId' + orderId).val();

        if (Utility.isEmpty(currencyId)) {

            alert('Parametre errerur')

            return;
        }

        const response = await this.props.orderService.updateOrderCurrency(orderId, currencyId);

        if (response.ok) {

            $('.message-holder').html(

                '<div class="alert alert-success order-alert">Devise mis a jour</div>'
            );

            $('.order-alert').delay(3000).fadeOut('slow');
        } else {

            $('.message-holder').html(

                '<div class="alert alert-danger order-alert">Erreur lors du mis a jour</div>'
            );

            $('.order-alert').delay(3000).fadeOut('slow');
        }
    }


    chooseTransferOrder = (e, orderId) => {
        e.preventDefault();

        let holder = 'order-item-row-' + orderId;

        localStorage.setItem('selectedStockOrder', orderId);

        Utility.showAlertWithId(holder, 'Commande Choisie pour le transfert', 'success', 'slow');

    }

    isOrderFullyLoad = async (e, orderId) => {

        e.preventDefault();


        const response = await this.props.orderService.isOrderFullyLoaded(orderId);

        if (response.ok) {

            $('#order-item-row-' + orderId).before(
                '<div class="alert alert-success">Tous les produits dans cette commande sont chargés</div>'
            );

            return;
        }

        $('#order-item-row-' + orderId).before(
            '<div class="alert alert-danger">Tous les produits ne sont pas chargés</div>'
        );
    }

    pickFromStock = async (e, orderId) => {

        e.preventDefault();

        try {

            const response = await this.props.orderService.pickOrderFromWarehouse(orderId);

            console.log(response.status);

            if (response.ok) {

                $('#order-item-row-' + orderId).before(
                    '<div class="alert alert-success alert-box">Commande Servie</div>'
                );
                $('.alert-box').delay(3000).fadeOut('slow');
            } else {

                $('#order-item-row-' + orderId).before(
                    '<div class="alert alert-danger alert-box">Probleme lors du service</div>'
                );
                $('.alert-box').delay(3000).fadeOut('slow');
            }

        } catch (error) {

            $('#order-item-row-' + orderId).before(
                '<div class="alert alert-danger alert-box">Probleme lors du service</div>'
            );
            $('.alert-box').delay(3000).fadeOut('slow');
        }





    }


    render() {

        const currencies = this.props.currencies;
        const customer = this.props.order.customer;
        let customerDetails = '';

        if (!Utility.isEmpty(customer)) {

            customerDetails = <div className='row bg-light text-primary border border-primary rounded mt-2'>
                <div className='col-md-4'><div className='text-start'>Nom: {customer.name}</div><div className='text-start'>Addresse: {customer.address}</div></div>
            </div>;




        }

        let chooseOrderForTransfer = '';

        if (this.props.order.type == 'STOCK') {

            chooseOrderForTransfer = <div>
                <button class="btn btn-primary mt-2 full-width" onClick={(e) => this.chooseTransferOrder(e, this.props.order.orderId)}>Choisi pour transfert</button>
            </div>;
        }

        let paymentLink = '';

        let attachCustomerLink = '';

        if (this.props.role == 'MANAGER' || this.props.role == 'SUPER-ADMIN') {

            paymentLink = <a href={'/admin/payment/add?orderId=' + this.props.order.orderId + '&countryId=' + this.props.order.countryId}><button className="btn btn-primary mt-2 full-width">Ajoute Payment</button></a>;


        }


        let pickButton = '';
        if (this.props.order.type != 'STOCK' && (this.props.role == 'MANAGER' || this.props.role == 'SUPER-ADMIN')) {


            pickButton = <button className='btn btn-primary full-width mt-2' onClick={(e) => this.pickFromStock(e, this.props.order.orderId)}>Sert au Cargo</button>;

        }

        return (
            <div className="card card-default mt-2" id=''>


                <div className="card-header text-center font-weight-bold">
                    <div className='row' id={'order-item-row-' + this.props.order.orderId}>
                        <div className='col mb-2'>
                            Balance: <NumberFormat
                                defaultValue={0}
                                value={this.props.order.balance}
                                thousandSeparator={true} decimalScale={2}
                                displayType="text" />
                        </div>
                        <div className='col'>
                            <div className='row'>
                                <div className='col'>Devise</div>
                                <div className='col'>
                                    <select className="form-control" id={"currencyId" + this.props.order.orderId} onChange={this.updateOrderCurrency} >
                                        <option></option>
                                        {currencies != undefined && currencies.length > 0 && currencies.map(currency =>

                                            this.props.order.currencyId == currency.currencyId ? <option key={currency.currencyId} value={currency.currencyId} selected={true}>{currency.name}</option> : <option key={currency.currencyId} value={currency.currencyId}>{currency.name}</option>

                                        )}
                                    </select>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-4">
                            <div>{this.props.order.createdDate}</div>
                            <div><textarea type="text" defaultValue={this.props.order.description} className="form-control" onBlur={(e) => this.updateDescription(this.props.order.orderId, e.target.value)} placeholder="Change Description" ></textarea></div>
                            <div className='mt-4 text-info fw-bold'>{this.props.order.orderUniqueNumber}</div>
                        </div>

                        <div className="col">


                            <div className="form-group">
                                <label className="label">Statut</label>
                                <select className="form-control" onChange={(e) => this.updateStatus(this.props.order.orderId, e.target.value)}>
                                    <option>New</option>
                                    {this.props.statuses.map(status =>

                                        status.name == this.props.order.status ? <option key={status.id} defaultValue={status.id} selected={true}>{status.name}</option> :
                                            <option value={status.id}>{status.name}</option>

                                    )}



                                </select>
                            </div>

                            <div className="form-group mt-2">

                                <label className="label">Choisi le Fournisseur</label>

                                <select className="form-control" id={"supplierId"} onChange={(e) => this.updateSupplier(this.props.order.orderId, e.target.value)}>
                                    <option></option>
                                    {this.props.suppliers.length > 0 && this.props.suppliers.map(supplier =>
                                        <option value={supplier.supplierId}>{supplier.name}</option>
                                    )}
                                </select>

                            </div>

                        </div>
                        <div className="col">
                            <div><a href={'/orderProducts?orderId=' + this.props.order.orderId + '&accessLevel=admin'}><button className="btn btn-primary">Produits</button></a></div>
                            <div><button className='btn btn-info mt-2' onClick={(e) => this.props.printOrder(this.props.order.orderId, e)}>Imprimer</button></div>
                            <div><button className="btn btn-primary mt-2" onClick={(e) => this.exportOrderToCSV(this.props.order.orderId)}>Exporter</button></div>

                        </div>
                        <div className="col">
                            <div>
                                <button className="btn btn-primary mt-2 full-width" onClick={() => this.select(this.props.order.orderId, 'admin')}>Ajoute Produits</button>
                            </div>
                            <div>
                                {paymentLink}
                            </div>

                            <div>
                                {attachCustomerLink}
                            </div>
                            {chooseOrderForTransfer}

                            <div>
                                <button className='btn btn-primary full-width mt-2' onClick={(e) => this.isOrderFullyLoad(e, this.props.order.orderId)}>Tous Chargé?</button>

                            </div>

                            <div>
                                {pickButton}
                            </div>
                            <div>
                               

                                <button
                                    className="btn btn-danger btn-sm mt-2 full-width"
                                    onClick={() => this.props.deleteOrder(this.props.order)}
                                >
                                    Supprimer
                                </button>
                            </div>
                        </div>
                    </div>

                    {customerDetails}


                </div>

            </div>

        )
    }
}

export default OrderItem;